/* ChairWala storefront helpers:
   1. A "bulk quote" call to action at the bottom of the menu drawer.
   2. Product names in the cart, the sticky add-to-cart bar and search results shown as a small
      type label above the name ("LOUNGE CHAIR - NIMBUS" reads "Lounge chair" / "Nimbus").
      Only the display changes; the product data in Shopify is untouched.
   3. A gentle fade-up for [data-cw-reveal] blocks as they scroll into view.
   4. Policy pages: hides stray CSS text and a second page heading that were pasted into a policy body.
      The policy text itself should still be tidied in Settings > Policies; this only keeps the page clean. */
(function () {
  var ARROW = '<svg class="cw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>';
  var NAME_TARGETS = '.cart-items__title, .sticky-add-to-cart__title, .resource-card[data-resource-type="product"] .resource-card__title';
  var QUOTE_URL = '/pages/bulk-orders';

  function addDrawerCta() {
    var drawer = document.querySelector('#header-component .menu-drawer');
    if (!drawer || drawer.querySelector('.cw-drawer-cta')) return;
    var box = document.createElement('div');
    box.className = 'cw-drawer-cta menu-drawer__animated-element';
    box.style.setProperty('--menu-drawer-animation-index', '7');
    box.innerHTML = '<p class="cw-drawer-cta__note">Furnishing an office, café or hotel? Tell us what you need and we will put together a quote.</p>' +
      '<a class="cw-btn cw-btn--primary" href="' + QUOTE_URL + '">Get a bulk quote ' + ARROW + '</a>';
    drawer.appendChild(box);
  }

  function titleCase(text) {
    return text.toLowerCase().replace(/(^|\s)(\S)/g, function (match, space, letter) { return space + letter.toUpperCase(); });
  }

  function splitName(raw) {
    var text = (raw || '').replace(/\s+/g, ' ').trim();
    var cut = text.lastIndexOf(' - ');
    if (cut < 1 || text !== text.toUpperCase()) return null;
    var kind = text.slice(0, cut).toLowerCase().split(' or ')[0];
    kind = kind.charAt(0).toUpperCase() + kind.slice(1);
    kind = kind.replace(/^Cafe\b/, 'Café').replace(/^Board room\b/, 'Boardroom');
    return { kind: kind, name: titleCase(text.slice(cut + 3)) };
  }

  function escapeHtml(text) {
    return text.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function formatNames() {
    Array.prototype.forEach.call(document.querySelectorAll(NAME_TARGETS), function (el) {
      if (el.querySelector('.cw-pname__title')) return;
      var parts = splitName(el.textContent);
      if (!parts) return;
      el.classList.add('cw-pname-js');
      el.innerHTML = '<span class="cw-pname__kind">' + escapeHtml(parts.kind) + '</span> <span class="cw-pname__title">' + escapeHtml(parts.name) + '</span>';
    });
  }

  function watchNames() {
    formatNames();
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; formatNames(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function setupReveal() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    var limit = window.innerHeight * 0.9;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cw-reveal]:not(.cw-reveal)'), function (el) {
      if (el.getBoundingClientRect().top < limit) return;
      el.classList.add('cw-reveal');
      observer.observe(el);
    });
  }

  function cleanPolicy() {
    if (window.location.pathname.indexOf('/policies/') !== 0) return;
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    var root = body.querySelector('.rte') || body;
    Array.prototype.slice.call(root.childNodes).forEach(function (node) {
      if (node.nodeType === 3 && /^\s*[a-z0-9#.,\s-]*\{[^}]*:[^}]*\}/i.test(node.textContent)) node.parentNode.removeChild(node);
    });
    Array.prototype.forEach.call(root.querySelectorAll('h1'), function (heading) { heading.parentNode.removeChild(heading); });
    var first = root.firstElementChild;
    if (first && first.tagName === 'P' && !first.textContent.replace(/ /g, '').trim()) first.parentNode.removeChild(first);
  }

  function init() {
    cleanPolicy();
    addDrawerCta();
    watchNames();
    setupReveal();
    document.addEventListener('toggle', function (event) {
      if (event.target && event.target.id === 'Details-menu-drawer-container') addDrawerCta();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();